import axios from "../../http/axios";
import {
    COMPANY_COUNTRIES_LOAD,
    COMPANY_OPPONENT_COUNTRIES_LOAD,
    COMPANY_TIMELINE_LOAD,
    COMPANY_TIMELINE_LOAD_SUCCESS
} from "./actionTypes";

export const loadTimeline = (name) => dispatch => {
    dispatch({type: COMPANY_TIMELINE_LOAD});
    axios.get("/company/statistics", {params: {companyName: name}})
        .then(response => {
            dispatch({type: COMPANY_TIMELINE_LOAD_SUCCESS, payload: response.data});
        });
};

export const getCountriesForCompany = (name) => dispatch => {
    axios.get(`/company/${name.toLowerCase()}/countries`).then(
        response => {
            dispatch({
                type: COMPANY_COUNTRIES_LOAD,
                payload: response.data
            })
        }
    )
}

export const getCountriesForOpponentCompany = (name) => dispatch => {
    axios.get(`/company/${name.toLowerCase()}/countries`).then(
        response => {
            dispatch({
                type: COMPANY_OPPONENT_COUNTRIES_LOAD,
                payload: response.data
            })
        }
    )
}
